import { TypeChecker } from '@attain-apps/type-guards'

/**
 * A project identifier as it appears in BCH cash draw and justification files.
 */
export type ProjectId = string
export namespace ProjectId {
  export const isProjectId: TypeChecker<ProjectId> = TypeChecker.isString
}
